module.exports = __webpack_public_path__ + "img/logo serra azul.44d14731.png";